import React, { useEffect } from 'react';
import useEncodedUrlId from '../../../../customHooks/useEncodedUrlId';
import {
    useContractDetail,
    useContractDetailData,
} from '../../../contextsProperty/ContextContractDetail';
import useLanguage from '../../../../customHooks/useLanguage';
import '../../../../stylesheets/stylesLayout/contracts-page.scss';
import useTranslate from '../../../../customHooks/useTranslate';
import { useHistory } from 'react-router-dom';
import routes from '../../../../utils/commonVariables/routes';
import IconButton from '../../../../muiComponents/IconButton';
import MainInformation from './MainInformation';
import Seasonality from './Seasonality';
import Rooms from './Rooms';
import MealPlans from './MealPlans';
import RateDates from './RateDates';
import CancellationPolicies from './CancellationPolicies';

const StaticRatesContractDetail = () => {
    const IdContract = useEncodedUrlId('encodedIdContract');
    const translate = useTranslate();
    const language = useLanguage();
    const history = useHistory();

    const { getContract } = useContractDetail();
    const { name } = useContractDetailData();

    useEffect(() => {
        if (IdContract && IdContract !== 'new') {
            getContract(IdContract);
        }
    }, [IdContract, language]);

    const closePage = () => {
        history.push(routes.landingPrivate + routes.contracts);
    };

    return (
        <div className='contract-detail__container'>
            <div className='contract-detail__title'>
                <h1>{name || translate('new_contract')} </h1>
                <IconButton iconName='Close' onClick={closePage} />
            </div>
            <main className='contract-detail__main'>
                <MainInformation />
                <Seasonality />
                <Rooms />
                <MealPlans />
                <RateDates />
                <CancellationPolicies />
            </main>
        </div>
    );
};

export default StaticRatesContractDetail;
